import { DIE_RESULT } from './die.model';
import { Item } from './item.model';

export type ACTION_TYPE = 'ATTACK' | 'MOVE' | 'OBJECTIVE' | 'FALLBACK' | 'DEFEND' | 'STRIKE';
export type RESPONSE_METHOD = 'RANGED' | 'MELEE' | 'BOTH' | 'NONE';

export const ACTIONS: { [key: string]: ACTION_TYPE } = {
    ATTACK: 'ATTACK',
    MOVE: 'MOVE',
    OBJECTIVE: 'OBJECTIVE',
    FALLBACK: 'FALLBACK',
    DEFEND: 'DEFEND',
    STRIKE: 'STRIKE'
};

export interface UnitAI {
    name: string;
    selected: boolean;
    equipment: string[];
    targetPriority: string[];
    specialInstructions: string;
    matrix: AIBehaviourCondition[];
    packs?: string[];
    isDynamic?: boolean;
}

export interface BehaviourResponse {
    response: ACTION_TYPE;
    method: RESPONSE_METHOD;
    breakEngagement: boolean;
    reckless: boolean;
    nextAction?: BehaviourResponse;
    forced?: boolean;
    dieResult: DIE_RESULT;
}

export interface AIBehaviourCondition {
    conditionType: 'HEALTH' | 'BOOLEAN' | 'MULTI';
    headerText?: string;
    healthMin: number;
    healthMax: number;
    question?: string;
    answer?: string;
    reverse?: boolean;
    hidden?: boolean;
    results: { [key: string]: BehaviourResponse };
}

export interface NaturalBehavior extends Item {
    id: number;
    name: string;
    listName?: string;
    icons: string[];
    packs: string[];
    flippable: boolean;
    cardType: string;
    cssClass: string;
    ai: {
        name: string;
        ai: UnitAI;
    };
}
